import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustodieTypeComponent } from './custodie-type.component';
import { AddCustodieTypeComponent } from './add-custodie-type/add-custodie-type.component';
import { EditCustodieTypeComponent } from './edit-custodie-type/edit-custodie-type.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        CustodieTypeComponent,
        AddCustodieTypeComponent,
        EditCustodieTypeComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [CustodieTypeComponent],
})
export class CustodieTypeModule { }
